import { Box, Typography, useTheme } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { useTranslation } from "react-i18next";
import { tokens } from "../theme";

const NoData = ({ children }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 1,
        py: 6,
        px: 2,
      }}
    >
      <InboxOutlinedIcon sx={{ fontSize: 48, color: colors.grey[300] }} />
      <Typography
        variant="body1"
        sx={{ color: colors.grey[300], fontWeight: 600 }}
      >
        {children || t("common.noData")}
      </Typography>
    </Box>
  );
};

export default NoData;
